import type {PageRouteConfig} from '@router';

import CpcDetails from 'modules/Cpc/Details/CpcDetails';
import {routes} from 'routes/routes';

export function createCpcDetailsRoute(): PageRouteConfig {
  return {
    element: <CpcDetails />,
    layout: {
      title: 'کلیک',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.CPC_LIST
    }
  };
}
